import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Edit2"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.3725 12.8871C13.4984 12.8871 13.6004 12.9884 13.6004 13.1135V14.1737C13.6004 14.2987 13.4984 14.4001 13.3725 14.4001H2.62825C2.50241 14.4001 2.40039 14.2987 2.40039 14.1737V13.1135C2.40039 12.9884 2.50241 12.8871 2.62825 12.8871H13.3725ZM9.52063 1.73226C9.68331 1.57109 9.93836 1.55713 10.117 1.69148L10.16 1.72815L12.2593 3.75488C12.4218 3.91184 12.4419 4.16089 12.3142 4.34043L12.2792 4.38378L5.51052 11.7986H2.96718C2.73347 11.7986 2.54085 11.6238 2.51452 11.3986L2.51146 11.3458V8.6765L9.52063 1.73226Z",
  fill: "#A5ACBE"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var edit_2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { edit_2 as default };
